import { Badge, Tooltip } from "@atoms"

import { Table } from "@organisms"

import styles from "./BadgesCell.module.scss"
import { BadgesCellProps } from "./BadgesCell.types"

export default function BadgesCell(props: BadgesCellProps) {
    const { badges, isLoading } = props

    const badgeQuantity = badges.length
    const twoBadges = badgeQuantity === 2
    const multipleBadges = badgeQuantity > 2
    const singleBadge = badgeQuantity === 1

    if (isLoading) {
        return <Table.Cells.SkeletonCell variant="badge" />
    } else if (multipleBadges) {
        return (
            <Tooltip body={badges.join("\n")} defaultPlacement="bottom" wrapChildren={false}>
                <div className={styles.base}>
                    <Badge size="sm">{badges[0]}</Badge>
                    <Badge size="sm">{`+${badgeQuantity - 1}`}</Badge>
                </div>
            </Tooltip>
        )
    } else if (twoBadges) {
        return (
            <div className={styles.base}>
                <Badge size="sm">{badges[0]}</Badge>
                <Badge size="sm">{badges[1]}</Badge>
            </div>
        )
    } else if (singleBadge) {
        return (
            <div className={styles.base}>
                <Badge size="sm">{badges[0]}</Badge>
            </div>
        )
    } else {
        return <Table.Cells.NoValueCell />
    }
}
